import { h } from 'preact'
import { connectRefinementList } from 'react-instantsearch-dom'
import Count from './ResultsCount'
import Checkbox from '../../../control-components/ui-components/Checkbox'
import Phrase from '../../../libs/translationsUtils/phrase'
import { SearchHit } from '../types'

type SourceType = 'freshdesk' | 'community' | 'knowledge_base' | 'zendesk' | 'salesforce' | 'skilljar'

interface Props {
  items: SearchHit[]
  title: string
  isFromSearch: boolean
  refine: (val: string) => void
  searchForItems: (val: string) => void
  createURL: (val: string) => string
}

const labelMapping: Record<SourceType, JSX.Element> = {
  community: <Phrase m='Forum' p='nav.title.community' />,
  knowledge_base: <Phrase m='Common' p='advanced.search.filter.knowledgebase.category' />,
  zendesk: <Phrase m='Forum' p='federated.search.zendesk' />,
  salesforce: <Phrase m='Forum' p='federated.search.salesforce' />,
  skilljar: <Phrase m='Forum' p='federated.search.skilljar' />,
  freshdesk: <Phrase m='Forum' p='federated.search.freshdesk' />
}

const SourceTypesList = ({
  title,
  items,
  refine
}: Props) => {
  return (
    <div className='instant-search__source-type-filter'>
      <span className='instant-search__filter-title'>{title}</span>
      {!items.length
        ? <div class='instant-search__filter-no-results'><Phrase p='No results' m='Control' /></div>
        : (
          <ul>
            {items.map(item => (
              <li key={item.label} className='instant-search__filter-list-item'>
                <div className={`instant-search-filter__label-wrapper ${item.isRefined ? 'refined' : ''}`}>
                  <Checkbox
                    label={labelMapping[item.label as SourceType]}
                    onUpdate={() => refine(item.value)}
                    qaClasses='topic-type-checkbox'
                    checked={item.isRefined}
                  />
                  <Count count={item.count} />
                </div>
              </li>
            ))}
          </ul>
          )}
    </div>
  )
}

export default connectRefinementList(SourceTypesList)
